// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + {"152":"base","332":"detail"}[chunkId] + "." + {"152":"b8f48a8e","332":"012bf869"}[chunkId] + ".css";
};